import React from "react";
import {
  Bed,
  Bath,
  Square,
  DollarSign,
  Home,
  Ruler,
  Banknote,
} from "lucide-react";

import { MLSDetailResponse } from "../../../api/mls";

type PropertyType = MLSDetailResponse["data"]["listing"]["property"];

interface PropertyBasicInfoProps {
  property?: PropertyType;
  pricePerSqFt?: number;
  formatPrice?: (price: number) => string;
}

export const PropertyBasicInfo: React.FC<PropertyBasicInfoProps> = ({
  property,
  pricePerSqFt,
  formatPrice,
}) => {
  return (
    <div className="mt-3 sm:mt-4 mb-2">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4 md:gap-6">
        <div className="flex flex-col items-center bg-gray-100 rounded-lg px-3 py-4 sm:px-4 sm:py-6">
          <p className="text-sm sm:text-base text-gray-500 mb-2">Bedrooms</p>
          <div className="flex items-center gap-2">
            <Bed className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" />
            <p className="text-lg sm:text-2xl font-bold text-gray-800">
              {property?.bedroomsTotal || "-"}
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center bg-gray-100 rounded-lg px-3 py-4 sm:px-4 sm:py-6">
          <p className="text-sm sm:text-base text-gray-500 mb-2">Bathrooms</p>
          <div className="flex items-center gap-2">
            <Bath className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" />
            <p className="text-lg sm:text-2xl font-bold text-gray-800">
              {property?.bathroomsTotal || "-"}
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center bg-gray-100 rounded-lg px-3 py-4 sm:px-4 sm:py-6">
          <p className="text-sm sm:text-base text-gray-500 mb-2">Square Feet</p>
          <div className="flex items-center gap-2">
            <Ruler className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" />
            <p className="text-lg sm:text-2xl font-bold text-gray-800">
              {property?.livingArea
                ? parseFloat(property.livingArea).toLocaleString()
                : "-"}
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center bg-gray-100 rounded-lg px-3 py-4 sm:px-4 sm:py-6">
          <p className="text-sm sm:text-base text-gray-500 mb-2">Price/Sqft</p>
          <div className="flex items-center gap-2">
            <Banknote className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" />
            <p className="text-lg sm:text-2xl font-bold text-gray-800">
              {pricePerSqFt && formatPrice
                ? formatPrice(Number(pricePerSqFt))
                : "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
